import store from "../../../../redux/store";

// Demo investigations render synthetic ("fake") analytics on the frontend so
// sales/onboarding logins look populated instead of empty. The decision is keyed
// off the current investigation's `demo` flag (surfaced by the API in the
// investigation DTO). The analytics endpoint files already ship a full mock
// dataset gated behind the VITE_MOCK_OUTPATIENTS-style env flags; this helper
// lets those same mocks turn on automatically for demo investigations without a
// global env toggle (which would also fake real tenants).
export const isCurrentInvestigationDemo = (): boolean => {
    try {
        const state: any = store.getState();
        return !!state?.investigations?.currentInvestigation?.demo;
    } catch {
        return false;
    }
};

interface MockConfig {
    enabled: boolean;
    endpoints: Record<string, boolean>;
}

// Single source of truth for the per-endpoint mock gate, shared by every
// analytics endpoint file so the "should this endpoint serve a synthetic
// response?" decision lives in one place instead of being copy-pasted (and
// drifting) across files. An endpoint mocks when the env flag is on OR the
// current investigation is a demo, AND the endpoint is mockable AND a mock
// generator exists for it.
export const shouldServeMock = (
    endpointPath: string,
    mockConfig: MockConfig,
    mockRegistry: Record<string, unknown>,
): boolean =>
    (mockConfig.enabled || isCurrentInvestigationDemo()) &&
    !!mockConfig.endpoints[endpointPath] &&
    !!mockRegistry[endpointPath];
